module.exports = __webpack_public_path__ + "static/media/spring-che-big-mobile@2x.ad9142eb.png";